{
  "name": "@transak/transak-sdk",
  "version": "3.1.3",
  "description": "Transak SDK that allows you to easily integrate fiat on/off ramp",
  "type": "module",
  "types": "lib/index.d.ts",
  "main": "lib/index.cjs",
  "exports": {
    ".": {
      "import": {
        "types": "./lib/index.d.ts",
        "default": "./lib/index.js"
      },
      "require": {
        "types": "./lib/index.d.cts",
        "default": "./lib/index.cjs"
      }
    }
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "packageManager": "pnpm@9.5.0+sha256.fc4a49bd609550a41e14d20efbce802a4b892aa4cac877322de2f0924f122991",
  "files": [
    "lib/**/*"
  ],
  "scripts": {
    "eslint": "eslint . --ext .ts",
    "eslint:fix": "pnpm eslint --fix",
    "build": "tsc && tsup",
    "prepack": "pnpm build",
    "packDev": "pnpm pack"
  },
  "author": "Transak",
  "license": "ISC",
  "homepage": "https://docs.transak.com/docs/web-integration#transak-sdk-reactvueangularts",
  "repository": {
    "type": "git",
    "url": "https://github.com/Transak/transak-sdk"
  },
  "dependencies": {
    "events": "^3.3.0",
    "pako": "^2.1.0",
    "query-string": "^8.2.0"
  },
  "devDependencies": {
    "@types/events": "^3.0.3",
    "@types/pako": "^2.0.3",
    "eslint": "^8.56.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-airbnb-typescript": "^17.1.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-eslint-comments": "^3.2.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-no-relative-import-paths": "^1.5.3",
    "eslint-plugin-prettier": "^5.1.3",
    "eslint-plugin-promise": "^6.1.1",
    "prettier": "^3.2.5",
    "tsup": "^8.0.2",
    "typescript": "^5.3.3"
  },
  "keywords": [
    "crypto",
    "cryptocurrency",
    "fiat",
    "on",
    "off",
    "ramp",
    "sdk",
    "ts",
    "js"
  ]
}
